import { Box, Text } from 'grommet';
import React from 'react';
import './PatientConscious.css';

const PatientConscious = () => {
    return (
            <Box className="patient-condition-bar">
                <Text className='patient-conasciopus-title'>Patient is Conscious</Text>
            </Box>
    );
}

export default PatientConscious;
